import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ChevronDown, ArrowUpRight, Gauge, LayoutGrid, Scale } from "lucide-react";
import { Wordmark } from "./Wordmark";
import { FREE_TOOLS } from "./freeTools";
import { FreeToolsModal } from "@/components/home/FreeToolsHero";

const A = "https://alpha.tradrquant.com";
const LIVE = FREE_TOOLS;
const EXPLORE = [
  { t: "Order flow features", href: "/order-flow", Icon: Gauge, id: "order-flow" },
  { t: "Terminal modules", href: "/terminal", Icon: LayoutGrid, id: "modules" },
  { t: "Compare", href: "/compare", Icon: Scale, id: "compare" },
];
const LINKS = [
  { label: "How it works", href: "/#how", id: "how-it-works" },
  { label: "Engine", href: "/#engine", id: "engine" },
  { label: "Research", href: "/research", id: "research" },
  { label: "Academy", href: "/learn", id: "academy" },
  { label: "About", href: "/about", id: "about" },
];

const NavLink = ({ href, id, children, onClick, className = "" }) => (
  <a href={href} onClick={onClick} data-testid={`nav-${id}`} className={`group relative whitespace-nowrap text-[13px] font-medium text-[#9DA3AE] transition-colors duration-300 hover:text-[#ECEBE4] ${className}`}>
    {children}
    <span className="absolute -bottom-1.5 left-0 h-px w-full origin-left scale-x-0 bg-[#ECEBE4]/70 transition-transform duration-300 group-hover:scale-x-100" />
  </a>
);

const Products = () => {
  const [all, setAll] = useState(false);
  return (
  <div className="group relative">
    <button type="button" data-testid="nav-products-trigger" className="flex items-center gap-1 text-[13px] font-medium text-[#9DA3AE] transition-colors duration-300 group-hover:text-[#ECEBE4]">
      Products <ChevronDown size={13} className="transition-transform duration-300 group-hover:rotate-180" />
    </button>
    <div className="invisible absolute left-1/2 top-full -translate-x-1/2 translate-y-1 pt-4 opacity-0 transition-[opacity,transform,visibility] duration-200 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100">
      <div data-testid="nav-products-menu" className="grid w-[620px] grid-cols-[1.4fr_1fr] border border-white/[0.09] bg-[#0B0C0F] shadow-[0_40px_100px_-30px_rgba(0,0,0,1)]">
        <div className="p-3">
          <p className="px-3 pb-2 pt-1 font-mono text-[9px] uppercase tracking-[0.24em] text-[#5A6170]">Free tools · live now</p>
          {LIVE.map((x) => (
            <a key={x.id} href={x.href} data-testid={`nav-product-${x.id}`} className="group/i flex items-start gap-3 px-3 py-2.5 transition-colors hover:bg-white/[0.035]">
              <x.Icon size={15} className="mt-0.5 text-white/30 transition-colors group-hover/i:text-[#BACD1C]" />
              <span><span className="block text-[13px] font-medium text-[#ECEBE4]">{x.t}</span><span className="block text-[12px] text-[#5A6170]">{x.d}</span></span>
            </a>
          ))}
          <button type="button" onClick={() => setAll(true)} data-testid="nav-all-free-tools" className="mx-3 mt-2 flex w-[calc(100%-1.5rem)] items-center justify-between border-t border-white/[0.07] pt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[#9DA3AE] hover:text-[#ECEBE4]">
            See all free tools <ArrowUpRight size={12} />
          </button>
        </div>
        <div className="border-l border-white/[0.07] bg-white/[0.015] p-3">
          <p className="px-3 pb-2 pt-1 font-mono text-[9px] uppercase tracking-[0.24em] text-[#5A6170]">Explore</p>
          {EXPLORE.map((x) => (
            <a key={x.id} href={x.href} data-testid={`nav-explore-${x.id}`} className="group/i flex items-center gap-3 px-3 py-2.5 text-[13px] font-medium text-[#9DA3AE] transition-colors hover:bg-white/[0.035] hover:text-[#ECEBE4]">
              <x.Icon size={14} className="text-white/30" />{x.t}
            </a>
          ))}
          <Link to="/referral" data-testid="nav-explore-referral" className="mx-3 mt-4 block border border-white/[0.08] p-3 transition-colors hover:border-white/20">
            <span className="block font-mono text-[9px] uppercase tracking-[0.2em] text-[#5A6170]">Referral program</span>
            <span className="mt-1 block text-[13px] text-[#ECEBE4]">Founder pricing + 20% recurring at launch</span>
          </Link>
        </div>
      </div>
    </div>
    <FreeToolsModal open={all} onClose={() => setAll(false)} />
  </div>
  );
};

const MobileMenu = ({ close }) => (
  <nav data-testid="mobile-menu" data-lenis-prevent className="max-h-[calc(100dvh-6rem)] overflow-y-auto overscroll-contain border-t border-white/[0.07] bg-[#08090B] px-6 pb-8 xl:hidden">
    <p className="pb-2 pt-6 font-mono text-[9px] uppercase tracking-[0.24em] text-[#5A6170]">Free tools · live now</p>
    {LIVE.map((x) => (
      <a key={x.id} href={x.href} onClick={close} data-testid={`mobile-nav-${x.id}`} className="flex items-center justify-between border-b border-white/[0.05] py-3.5 text-[15px] text-[#ECEBE4]">
        {x.t}<ArrowUpRight size={14} className="text-white/30" />
      </a>
    ))}
    <p className="pb-2 pt-6 font-mono text-[9px] uppercase tracking-[0.24em] text-[#5A6170]">Explore</p>
    {[...LINKS, { label: "Order flow features", href: "/order-flow", id: "order-flow" }, { label: "Terminal modules", href: "/terminal", id: "modules" }, { label: "Compare", href: "/compare", id: "compare" }, { label: "Referral", href: "/referral", id: "referral" }, { label: "Legal · Risk notice", href: "/risk", id: "legal" }].map((l) => (
      <a key={l.id} href={l.href} onClick={close} data-testid={`mobile-nav-${l.id}`} className="block border-b border-white/[0.05] py-3.5 text-[15px] text-[#9DA3AE]">{l.label}</a>
    ))}
    <a href={A} onClick={close} data-testid="mobile-nav-cta" className="mt-6 block bg-[#BACD1C] px-4 py-3.5 text-center font-mono text-xs uppercase tracking-[0.16em] text-black">Open free terminal</a>
  </nav>
);

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const solid = scrolled || open;
  return (
    <header data-testid="site-header" className={`fixed left-0 right-0 top-9 z-50 border-b transition-[background-color,border-color] duration-300 ${solid ? "border-white/[0.06] bg-[#08090B]/[0.92] backdrop-blur-md" : "border-transparent bg-transparent"}`}>
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-6 md:h-20 md:px-12">
        <a href="/#top" data-testid="logo" onClick={() => setOpen(false)}><Wordmark /></a>
        <nav className="hidden items-center gap-11 xl:flex">
          <Products />
          {LINKS.map((l) => <NavLink key={l.id} {...l}>{l.label}</NavLink>)}
        </nav>
        <div className="flex items-center gap-8">
          <Link to="/referral" data-testid="nav-referral" className="hidden text-[13px] font-medium text-[#9DA3AE] transition-colors hover:text-[#ECEBE4] xl:inline">Referral</Link>
          <a href={A} data-testid="nav-cta" className="group hidden items-center gap-1.5 bg-[#BACD1C] px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.14em] text-black transition-[background-color,transform] duration-300 hover:bg-[#ECEBE4] active:scale-95 sm:inline-flex">
            Open terminal <ArrowUpRight size={13} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
          <button onClick={() => setOpen((v) => !v)} data-testid="nav-menu-toggle" aria-label="Toggle menu" className="inline-flex h-10 w-10 items-center justify-center border border-white/[0.12] text-[#ECEBE4] transition-colors hover:border-white/30 xl:hidden">
            {open ? <X size={17} /> : <Menu size={17} />}
          </button>
        </div>
      </div>
      {open && <MobileMenu close={() => setOpen(false)} />}
    </header>
  );
};
